import styled, { css } from 'styled-components';

export const CarrierSprt = styled.span`
  ${props =>
    props.url &&
    css`
      background: url('${props.url}') no-repeat 0 -81px;
    `}
  background-size: 16px 232px;
  width: 16px;
  height: 16px;
  margin-right: ${props => props.theme.spacing.small};

  &.carrier6E {
    background-position: 0 0;
  }
  &.carrierAI {
    background-position: 0 -18px;
  }

  &.carrierG8 {
    background-position: 0 -32px;
  }

  &.carrierSG {
    background-position: 0 -49px;
  }

  &.carrier9I {
    background-position: 0 -67px;
  }

  &.carrierDefault {
    background-position: 0 -81px;
  }

  &.carrierI5 {
    background-position: 0 -107px;
  }
  &.carrierIX {
    background-position: 0 -107px;
  }

  &.carrierUK {
    background-position: 0 -128px;
  }

  &.carrier2T {
    background-position: 0 -145px;
  }

  &.carrierS5 {
    background-position: 0 -165px;
  }

  &.multi-carr {
    background-position: 0 -182px;
  }
  &.carrierQP {
    background-position: 0 -196px;
  }
  &.carrierIC {
    background-position: 0px -215px;
  }
`;
